import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { VideoPlayer as CotopaxiVideoPlayer } from '@as/cotopaxi';
import { getPictureSrcset } from '../../util/ImageUtil';
const VideoPlayer = ({ poster, video }) => {
    const { isEditor, imageCdnPrefix } = useAemConfig();
    const config = {
        link: video.link,
        autoplay: video.autoplay && !isEditor,
        heightType: video.heightType,
        height: video.height,
        muted: video.muted,
        controls: !video.hideControls,
    };
    const overlay = (poster === null || poster === void 0 ? void 0 : poster.image)
        ? {
            src: poster.image.imagePath,
            srcset: getPictureSrcset({
                imagePath: poster.image.imagePath,
                renditions: poster.image.renditions,
                lastModified: poster.image.lastModified,
            }, imageCdnPrefix),
            isPicture: true,
            lazy: true,
        }
        : undefined;
    return _jsx(CotopaxiVideoPlayer, { poster: overlay, config: config });
};
export default VideoPlayer;
